import {find} from "underscore";

import {Size} from "../../../../geom";

/**
 *
 * Available box sizes. Uploaded images will be resized in order to fit into these boxes.
 * The same constant can pe found in the Lambda ImageResizer function.
 * IMPORTANT: Make sure to modify that constant as well when you're changing this one.
 */
export const BOX_SIZES: Size[] = [
    new Size(3840, 3840),
    new Size(2560, 2560),
    new Size(2048, 2048),
    new Size(1536, 1536),
    new Size(1280, 1280),
    new Size(1080, 1080),
    new Size(960, 800),
    new Size(910, 448),
    new Size(720, 450),
    new Size(480, 320),
    new Size(300, 300),
    new Size(100, 100),
    new Size(50, 50)
];

/**
 * Checks if the original image fits the passed box size.
 * @param imageBoxSize
 * @param availableBoxSize
 */
const isBoxSizeFitting = (imageBoxSize: Size, availableBoxSize: Size) => {
    return imageBoxSize.width <= availableBoxSize.width && imageBoxSize.height <= availableBoxSize.height;
};

/**
 * Returns the first appropriate box size in which the image would fit.<p>
 *
 * If will first filter out all box sizes in which the original
 * image already fit (the original image was smaller than the box size,
 * so no resize was necessary).
 *
 * Then it will iterate trough the available box sizes and will choose the smallest one
 * that is bigger than the bounds (so that we don't scale it down).
 *
 * @param imageBoxSize
 * @param bounds
 */
export const getAppropriateBoxSize = (imageBoxSize: Size, bounds: Size) => {
    const availableBoxSizes = BOX_SIZES.filter(boxSize => !isBoxSizeFitting(imageBoxSize, boxSize));

    return find(availableBoxSizes.sort((a, b) => a.width - b.width), boxSize => isBoxSizeFitting(bounds, boxSize));
};



// WEBPACK FOOTER //
// ./src/shared/xp/components/widgets/image/util/ImageBoxSize.ts